<template>
    <Modal>
        <template #title>Forgot your password?</template>

        <template v-if="success">
            <p>
                Success! If there is an account associated with that e-mail,
                we have sent a link to reset your password.
            </p>
        </template>

        <template v-else>
            <p>
                We will email you a link to reset you password.
                Use only your account e-mail address.
            </p>

            <form id="form" @submit.prevent="formSubmit">
                <div class="form-field">
                    <label class="form-field-label">E-mail</label>
                    <input type="text" name="email" v-model.trim="email"/>
                    <small v-if="errorEmail" class="error-text">{{ errorEmail }}</small>
                </div>
            </form>
        </template>

        <template #footer v-if="success">
            <Button @click="closeModal">Done</Button>
        </template>
        <template #footer v-else>
            <Button class="gray" @click="closeModal">Cancel</Button>

            <Button type="submit" form="form" :loading="sendStatus">Send a link</Button>
        </template>
    </Modal>
</template>

<script>
    import { mapActions } from 'vuex';
    import Modal from "../../components/Modal";
    import Button from "../../components/Button";

    export default {
        name: "ForgotPasswordModal",

        components: {
            Button,
            Modal,
        },

        data() {
            return {
                success: false,
                email: '',
                errorEmail: '',
                sendStatus: false,
            }
        },

        methods: {
            ...mapActions('authentication', [
                'forgotPassword',
            ]),

            closeModal() {
                this.$emit('closeModal');
            },

            resetErrors() {
                this.errorEmail = false;
            },

            formSubmit() {
                this.resetErrors();

                let email = this.email;

                if (!email.length) {
                    this.errorEmail = 'Field is required';

                    return;
                }

                this.sendStatus = true;

                this.forgotPassword({email})
                    .then(() => {
                        this.success = true;
                    })
                    .catch(error => {
                        this.errorEmail = error;
                    })
                    .finally(() => {
                        this.sendStatus = false;
                    });
            },
        },

    }
</script>

<style lang="scss">

</style>